export default "__VITE_ASSET__E84Ot$wt__"